<template>
  <form @submit.prevent="handleSubmit">
    <div>
      <router-link to="/" class="has-margin-top is-inline-block is-pulled-right">Tillbaka</router-link>
    </div>

    <div class="field">
      <div class="control has-icons-left has-icons-right">
        <input
          class="input"
          type="email"
          name="email"
          placeholder="E-post"
          v-model="email"
          v-validate:email="'required|email'"
          :disabled="isProcessing"
          :class="{ 'is-invalid': submitted && !email }"
          @change="clearErrors"
          >
      </div>
    </div>

    <button type="submit" class="login-button" :disabled="isProcessing">
      <i v-if="isProcessing" class="fal fa-spinner-third fa-spin"></i> Skicka
    </button>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
// import { setErrorsFromResponse } from '@/helpers'
export default {
  data () {
    return {
      isProcessing: false,
      email: '',
      submitted: false
    }
  },
  methods: {
    ...mapActions('auth', ['generateToken']),

    clearErrors () {
      this.$validator.reset()
    },

    handleSubmit (e) {
      this.submitted = true
      if (this.email) {
        this.generateToken({ email: this.email })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Login/ForgotPasswordPage.vue